import React from 'react';
import { UsersIcon, StarIcon, FileStackIcon, TrophyIcon, BriefcaseIcon, Building2Icon, Users2Icon, GraduationCapIcon, FolderOpenIcon, HomeIcon } from 'lucide-react';
export function SocialProofBar() {
  const types = [{
    icon: BriefcaseIcon,
    text: 'Contador Independiente'
  }, {
    icon: Building2Icon,
    text: 'Estudios Contables'
  }, {
    icon: Users2Icon,
    text: 'Contador con Empleados'
  }, {
    icon: GraduationCapIcon,
    text: 'Contador Recién Egresado'
  }, {
    icon: FolderOpenIcon,
    text: 'Contador con Cartera Grande'
  }, {
    icon: HomeIcon,
    text: 'Contador que Trabaja desde Casa'
  }];
  return <section className="bg-white border-b border-gray-200 py-6 shadow-sm relative z-20" data-id="element-160">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-161">
        <p className="text-center text-sm font-bold text-[#1e3a5f] mb-4" data-id="element-162">
          El sistema de gestión documental más completo y profesional del
          mercado
        </p>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-center mb-6" data-id="element-163">
          {[{
          icon: UsersIcon,
          value: '+500',
          label: 'Contadores confían'
        }, {
          icon: StarIcon,
          value: '4.9/5',
          label: 'Valoración promedio',
          fill: true
        }, {
          icon: FileStackIcon,
          value: '+180',
          label: 'Plantillas incluidas'
        }, {
          icon: TrophyIcon,
          value: '#1',
          label: 'Sistema en Argentina'
        }].map((stat, i) => <div key={i} className="flex items-center justify-center gap-2" data-id="element-164">
              <stat.icon className={`w-5 h-5 text-[#d4a017] flex-shrink-0 ${stat.fill ? 'fill-current' : ''}`} data-id="element-165" />
              <div className="text-left" data-id="element-166">
                <span className="text-lg font-black text-gray-900 block leading-tight" data-id="element-167">
                  {stat.value}
                </span>
                <span className="text-xs text-gray-500 font-medium" data-id="element-168">
                  {stat.label}
                </span>
              </div>
            </div>)}
        </div>

        <div className="border-t border-gray-100 pt-5" data-id="element-169">
          <h2 className="text-sm font-bold text-center text-[#1e3a5f] mb-4" data-id="element-170">
            Funciona para todo tipo de contador:
          </h2>
          <div className="grid grid-cols-3 md:grid-cols-6 gap-2" data-id="element-171">
            {types.map((type, index) => <div key={index} className="flex flex-col items-center text-center" data-id="element-172">
                <div className="bg-[#1e3a5f]/5 p-2 rounded-full mb-1.5 text-[#1e3a5f]" data-id="element-173">
                  <type.icon className="w-4 h-4" data-id="element-174" />
                </div>
                <h3 className="font-semibold text-gray-600 text-[10px] leading-tight max-w-[100px]" data-id="element-175">
                  {type.text}
                </h3>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}